import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShareAndroid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 5.5C20 7.433 18.433 9 16.5 9C15.4884 9 14.5771 8.57086 13.9381 7.88469L8.82563 10.906C8.93879 11.2502 9 11.6179 9 12C9 12.382 8.93879 12.7498 8.82563 13.094L13.9383 16.1151C14.5773 15.4291 15.4885 15 16.5 15C18.433 15 20 16.567 20 18.5C20 20.433 18.433 22 16.5 22C14.567 22 13 20.433 13 18.5C13 18.1179 13.0612 17.7502 13.1744 17.406L8.06172 14.3849C7.42274 15.0709 6.51148 15.5 5.5 15.5C3.567 15.5 2 13.933 2 12C2 10.067 3.567 8.5 5.5 8.5C6.51148 8.5 7.42274 8.92906 8.06171 9.61511L13.1744 6.59399L13.1748 6.59518C13.0614 6.25065 13 5.88249 13 5.5C13 3.567 14.567 2 16.5 2C18.433 2 20 3.567 20 5.5ZM18.5 5.5C18.5 6.60457 17.6046 7.5 16.5 7.5C15.3954 7.5 14.5 6.60457 14.5 5.5C14.5 4.39543 15.3954 3.5 16.5 3.5C17.6046 3.5 18.5 4.39543 18.5 5.5ZM5.5 14C6.60457 14 7.5 13.1046 7.5 12C7.5 10.8954 6.60457 10 5.5 10C4.39543 10 3.5 10.8954 3.5 12C3.5 13.1046 4.39543 14 5.5 14ZM18.5 18.5C18.5 19.6046 17.6046 20.5 16.5 20.5C15.3954 20.5 14.5 19.6046 14.5 18.5C14.5 17.3954 15.3954 16.5 16.5 16.5C17.6046 16.5 18.5 17.3954 18.5 18.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgShareAndroid;
